import { render } from "./StartScreen.vue?vue&type=template&id=362598d6"
import script from "./StartScreen.vue?vue&type=script&lang=js"
export * from "./StartScreen.vue?vue&type=script&lang=js"

import exportComponent from "/Users/peterdevos/Apps/visma_reaction_game/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__